import React from "react"
import styled from "styled-components"

import { Text } from "components/atoms/Typography"
import Flex from "components/atoms/Flex"

import { breakpoints } from "utils/styled-constants"

const Line = styled.div`
  display: inline-block;
  border-bottom: 1px solid ${props => (props.invert ? "white" : "black")};
  width: 50px;
  height: 0px;
`

const Wrapper = styled.div`
  position: absolute;
  transform-origin: left;
  transform: rotate(-90deg);
  bottom: 100px;
  color: ${props => (props.invert ? "white" : "black")};
  display: none;

  @media (min-width: ${breakpoints.lg}) {
    left: 25px;
    display: block;
  }
  @media (min-width: ${breakpoints.xl}) {
    left: 30px;
  }
`

const VerticalText = ({ invert }) => {
  return (
    <Wrapper invert={invert}>
      <Flex alignItems="center">
        <Line invert={invert} />
        <Text color="inherit" fontSize="10px" ml={6}>
          TechAviv Founder Partners
        </Text>
        <Text color="inherit" fontSize="10px" fontWeight="600" ml={6}>
          EST. 2020
        </Text>
      </Flex>
    </Wrapper>
  )
}

export default VerticalText
